import { NativeService } from './../../../services/native.service';
import { SelectListComponent } from './select-list.component';
import { FieldModel } from 'app/models/shared/field.model';
import { GeneralService } from 'app/services/general.service';
import { LookupType, LookupExternalCollection, LookupInternalCollection, VehicleClass } from 'app/utility/enums';
import { SelectListModalComponent } from './select-list-modal.component';
import { Component, OnInit,  EventEmitter, Input, Output, ChangeDetectorRef } from '@angular/core';

import { ListItemModel } from 'app/models/shared/listItem.model';
import { Constants } from 'app/utility/constants';
import { ModalController } from '@ionic/angular';
import { UserService } from 'app/services/user.service';

@Component({
    selector: 'app-select-list-lazy-multi',
    templateUrl: './select-list-lazy-multi.component.html',
    styleUrls: ['./select-list-lazy-multi.component.scss'],
    standalone: false
})
export class SelectListLazyMultiComponent extends SelectListComponent implements OnInit {

	/* lazyload list usage */
	@Input() id: string = '';
	@Input() field: FieldModel;

	/* vehicle specific select*/
	@Input() detailClass: VehicleClass;

	@Input() selectedItemIds: string[]; //the ids of the selected values
	@Input() launchOnLoad: boolean = false;

	@Output() selectedItemIdsChange: EventEmitter<string[]> = new EventEmitter<string[]>();
	@Output() loaded: EventEmitter<string> = new EventEmitter<string>();

	selectedItems: ListItemModel[];

	constructor(public modalController: ModalController,
		public generalService: GeneralService,
		protected nativeService: NativeService,
		protected cd: ChangeDetectorRef,
		public userService: UserService,
	) {
		super(modalController, nativeService, cd, generalService);
		this.displayType = 'compact';
	}

	ngOnInit() {
		if (this.sideload && this.sideload.length) // || (!this.items || this.items.length == 0))
		{
			this.loadLookupItems();

			if (this.sideload[0] && this.sideload[0].lookupType == LookupType.External && this.sideload[0].canAddNewValues)
			{
				this.canAddNew = true;
			}
		}
		else {
			throw new Error("No valid sideload object supplied for multi-select list: " + this.label);
		}
	}

	protected configureSelectedItem() {
		//set the selected items
		this.selectedItems = [];
		this.setDisplayValue(false);
		if (this.launchOnLoad) {
			this.show();
		}
	}


	private loadLookupItems(clearCache: boolean = false, loadModal: boolean = false) {
		var item: ListItemModel;
		this.items = [];
		var firstSideload = this.sideload[0];
		if (firstSideload.lookupType == LookupType.External) {
			this.lookupType = LookupType.External;
			this.lookupCollection = firstSideload.collection;

			if (this.detailClass) {
				//now, fetch the lookups
				this.loading = true;

				this.generalService.getCachedExternalLookups(this.detailClass, <LookupExternalCollection>this.lookupCollection, null, clearCache)
					.subscribe
					({
						next: x => {
							// console.log(this.lookupCollection, this.items, x);
							this.items = x.map<ListItemModel>(y => new ListItemModel(y.id.toString(), y.caption));
							this.configureSelectedItem();

							setTimeout(() => {
								this.loading = false;
								this.cd.detectChanges();

								//if lookupInternal and min version is 3.2.14
								if (this.sideload.lookupInternal && this.userService.mcMinVersion("3.2.14"))
								{
									this.loadBaseInternalLookup(loadModal);
								}
								else if (loadModal) {
									this.showModal();
								}
							}, 0);
						},
						error: err =>
						{
							setTimeout(() => {
								this.loading = false;
								this.cd.detectChanges();
							}, 0);
							console.error(`getCachedExternalLookups`, err);
						}
                    });

			}
		}
		else if (firstSideload.lookupType == LookupType.Internal) {
			this.lookupType = LookupType.Internal;
			this.lookupCollection = firstSideload.collection;
			item = new ListItemModel(firstSideload.id, firstSideload.caption ? firstSideload.caption : "-");
			this.items.push(item);
			this.selectedItem = item;
			//now, fetch the lookups
			this.loading = true;
			this.generalService
				.getInternalLookups(<LookupInternalCollection>this.lookupCollection)
				.subscribe
				({
					next: x => {
						// console.log(this.lookupCollection, item.id, x);
						this.items = x.map<ListItemModel>(y => new ListItemModel(y.id.toString(), y.caption));
						this.configureSelectedItem();

						setTimeout(() => {
							this.loading = false;
							this.cd.detectChanges();
						}, 0);
					},
					error: err =>
					{

						setTimeout(() => {
							this.loading = false;
							this.cd.detectChanges();
						}, 0);
						console.error(`getInternalLookups`, err);
					}
                });
		}
	}

	show(): void {
		this.showModal();
	}

	async showModal() {
		var statusBarColor = this.nativeService.currentColor;
		this.nativeService.setupStatusBar("light");
		var originalSelectedIds = Object.assign([], this.selectedItemIds);
		const modal = await this.modalController.create({
			component: SelectListModalComponent,
			componentProps: {
				'id': this.id,
				'title': this.label,
				'items': this.items,
				'selectAllLabel': this.selectAllLabel,
				'selectedValue': this.selectedValue,
				'selectedItemIds': this.selectedItemIds,
				'displayType': this.displayType,
				'multiSelect': true,
				'allowRefresh': (this.lookupType == LookupType.External),
				'allowAdd': this.canAddNew,
				'codeLookupList': this.codeLookupList,
			}
		});
		await modal.present();
		const { data } = await modal.onDidDismiss();
		this.nativeService.setupStatusBar(statusBarColor);
		// console.log("Modal dismissed", data);
		if (data && data.refresh) {
			this.loadLookupItems(true, true);
		}
		else if (data && data.caption)
		{
			// console.log(data.caption);
			this.addNewLookup(data);
		}
		else if (data && data.changed) {
			this.setSelectedItems();
		}
		else {
			this.selectedItemIds = Object.assign([], originalSelectedIds);
		}
	}

	protected async addNewLookup(data: any)
	{
		// console.log(data);
		if (this.lookupType != LookupType.External)
		{
			throw `Add lookup for lookup type, ${this.lookupType}, not supported`;
		}

		// console.debug(`Add new lookup`, data.caption);

		this.loading = true;

		this.generalService.findOrCreateExternalLookupCached(data.caption, this.detailClass ? this.detailClass : VehicleClass.None, <LookupExternalCollection>this.lookupCollection, null).subscribe(
			x =>
			{
				// console.debug(`findOrCreateExternalLookupCached`, x);
				const item = new ListItemModel(x.id, x.caption);
				this.selectedItemIds.push(item.id);
				this.sideload.id  = x.id;
				this.sideload.caption = x.caption;
				this.loadLookupItems(true, true);

				setTimeout(() => {
					this.loading = false;
					this.cd.detectChanges();
				}, 0);
			},
			err =>
			{

				setTimeout(() => {
					this.loading = false;
					this.cd.detectChanges();
				}, 0);
				console.error(`Add new lookup failed`, data.caption);
			}
		);
	}

	setSelectedItem(item: ListItemModel, emit: boolean): void {
		//overridden as we don't want to use this function
	}

	setSelectedItems(): void {
		this.setDisplayValue();
		// console.log("setSelectedItems", this.selectedItemIds, this.field.value);
		this.selectedItemIdsChange.emit(this.selectedItemIds);
	}

	clearSelectedItem(): void {
		this.selectedItem = null;
		this.selectedItemId = Constants.EmptyGuid;
	}

	public setDisplayValue(emit: boolean = true) {
		// console.log("setDisplayValue", this.field.value);

		if (this.selectedItemIds) {
			this.selectedItems = this.items.filter(
				(x: ListItemModel) => (this.selectedItemIds.indexOf(x.id) >= 0)
			);
		}
		var captions: string[] = [];
		this.selectedItems.forEach(function (item) {
			captions.push(item.name);
		});
		this.selectedValue = captions.join(", ");

		if (emit) {
			// console.log("setDisplayValue loaded.emit");
			this.loaded.emit(this.selectedValue);
		}
	}

	getDisplayValue(): string {
		return (this.selectedValue && this.selectedValue.trim() != '') ? this.selectedValue : '-';
	}

	itemHasValue() {
		return (this.selectedValue && this.selectedValue.trim() != '');
	}
	scrollTop: boolean = true;
	ionScrollEvent(ev:any){
		var scrollTop = (ev.detail.scrollTop == 0);
		if (this.scrollTop!=scrollTop) {
			this.scrollTop = scrollTop;
		}
	}
}
